import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "form-control-checkbox" }

import { PropType } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import UmbracoFormInput from "@/components/umbraco-forms/inputs/UmbracoFormInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormMultipleChoice',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.preValues, (preValue) => {
    return (_openBlock(), _createElementBlock("div", {
      key: preValue.value,
      class: "form-group"
    }, [
      _createElementVNode("label", {
        for: `${__props.field.id}-${preValue.value}`,
        class: "umbraco-forms-label"
      }, _toDisplayString(preValue.caption), 9, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(UmbracoFormInput, {
          type: "checkbox",
          field: __props.field,
          value: preValue.value,
          id: `${__props.field.id}-${preValue.value}`
        }, null, 8, ["field", "value", "id"])
      ])
    ]))
  }), 128))
}
}

})